import { Box, Card, Typography } from "@mui/material";
import { ReactElement } from "react";
import { FormattedMessage } from "react-intl";

import CollapsibleDrawer from "~frontend/components/CollapsibleDrawer";
import { SendDetailsMini } from "~frontend/routes/subaccounts/campaignView/CampaignDetails";
import { ScriptPreview } from "~frontend/routes/subaccounts/campaignView/ScriptPreview";
import { CampaignForView } from "~frontend/routes/subaccounts/campaignView/types";
import { palette } from "~frontend/theme";

export function SendSummaryCard({
  campaign,
}: {
  campaign: CampaignForView;
}): ReactElement {
  return (
    <Card sx={{ border: 0 }}>
      <CollapsibleDrawer
        sxHeader={{
          backgroundColor: palette.midGray,
          marginRight: undefined,
          marginBottom: undefined,
        }}
        title={
          <Typography variant="body1Bold" sx={{ color: palette.navy, mx: 2 }}>
            <FormattedMessage
              defaultMessage="Send Summary"
              description="Summary of sending input"
            />
          </Typography>
        }
        startOpen={true}
      >
        <Box sx={{ backgroundColor: palette.lightestGray, p: 2 }}>
          <SendDetailsMini campaign={campaign} showTopBorder={false} />
          {campaign.scriptVariants
            .filter(v => !v.deletedAt)
            .map((variant, _index, arr) => (
              <Box key={variant.id} sx={{ mt: 2 }}>
                {arr.length > 1 && (
                  <Typography
                    variant="body2Bold"
                    sx={{
                      textTransform: "uppercase",
                      color: palette.darkGray,
                    }}
                  >
                    Script Variant {variant.displayOrder}
                  </Typography>
                )}
                <Box
                  sx={{
                    mt: 2,
                    borderRadius: "20px 20px 20px 0",
                    backgroundColor: palette.lightBlue,
                    p: 3,
                  }}
                >
                  <ScriptPreview
                    campaignId={campaign.id}
                    variant={variant}
                    sampleContactData={JSON.parse(
                      campaign.sampleContact?.data || "{}"
                    )}
                  />
                </Box>
              </Box>
            ))}
        </Box>
      </CollapsibleDrawer>
    </Card>
  );
}
